import Cookies from 'js-cookie'
/*
  This hook sets a rate-limited cookie to help improve the user experience,
  even without the cookie the application will correctly rate limit members.
  It exists primarily to prevent users from refreshing the page and attempting
  to log-in again.
*/
export const RateLimiter = {
  key: null,
  timeoutMilliseconds: null,
  eventName: null,
  domain: null,
  mounted() {
    this.setProperty('key', 'rateLimiterKey')
    this.setProperty('eventName', 'rateLimiterEvent')
    this.setProperty('timeoutMilliseconds', 'rateLimiterTimeout')

    const existingRateLimit = Cookies.get(this.key)

    if (existingRateLimit) {
      this.pushRateLimited(existingRateLimit)
    }

    this.handleEvent(this.eventName, event => {
      this.setCookie(event)
    })
  },
  setCookie(event) {
    const secure = true
    const timeoutMilliseconds = Number(this.timeoutMilliseconds)
    const expires = new Date(new Date().getTime() + timeoutMilliseconds)
    const value = expires.toISOString()
    const domain = window.APP_HOST

    Cookies.set(this.key, value, { expires, domain, secure })

    this.pushRateLimited(expires)
  },
  pushError(message) {
    this.pushEvent('rate-limiter-error', { message })
  },
  pushRateLimited(rateLimitedUntil) {
    this.pushEvent(this.eventName, { until: rateLimitedUntil })
  },
  setProperty(property, dataAttributeName) {
    const value = this.el.dataset[dataAttributeName]
    if (value === undefined) {
      this.pushError(`Missing required data attribute: "${dataAttributeName}"`)
    } else {
      this[property] = value
    }
  },
}
